import { useCallback, useMemo } from 'react';

import {
  useAuthenticateGoogle,
  useAuthenticateMicrosoft,
  useDeleteGoogleAuthentication,
  useDeleteMicrosoftAuthentication,
  useGetGrantForUser
} from '@/api/generated';

const useIntegrations = () => {
  const {
    data: userGrantResponse,
    refetch: refetchUserGrant,
    isLoading: userGrantLoading
  } = useGetGrantForUser();

  const userGrant = useMemo(
    () => userGrantResponse?.items?.[0] || null,
    [userGrantResponse?.items]
  );

  const { mutateAsync: mutateAuthenticateGoogle } = useAuthenticateGoogle();
  const { mutateAsync: mutateAuthenticateMicrosoft } = useAuthenticateMicrosoft();

  const { mutateAsync: mutateDeleteGoogleAuthentication } = useDeleteGoogleAuthentication();
  const { mutateAsync: mutateDeleteMicrosoftAuthentication } = useDeleteMicrosoftAuthentication();

  const authenticateGoogle = useCallback(
    async (authorizationCode: string, redirectUrl: string) => {
      await mutateAuthenticateGoogle({
        data: { authorizationCode, redirectUrl }
      });
    },
    [mutateAuthenticateGoogle]
  );

  const authenticateMicrosoft = useCallback(
    async (code: string, redirectUrl: string) => {
      await mutateAuthenticateMicrosoft({
        data: { code, redirectUrl }
      });
    },
    [mutateAuthenticateMicrosoft]
  );

  const deleteGoogleAuthentication = useCallback(async () => {
    await mutateDeleteGoogleAuthentication();
  }, [mutateDeleteGoogleAuthentication]);

  const deleteMicrosoftAuthentication = useCallback(async () => {
    await mutateDeleteMicrosoftAuthentication();
  }, [mutateDeleteMicrosoftAuthentication]);

  return {
    authenticateGoogle,
    authenticateMicrosoft,
    userGrant,
    refetchUserGrant,
    userGrantLoading,
    deleteGoogleAuthentication,
    deleteMicrosoftAuthentication
  };
};

export default useIntegrations;
